import type { ReactNode } from 'react';
import Button from '@mui/material/Button';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { StatusPage } from './StatusPage';

export function NotFoundPage(): ReactNode {
  const { t } = useTranslation('shell');
  return (
    <StatusPage
      icon={<SearchOffIcon fontSize="large" />}
      title={t('notFound.title')}
      description={t('notFound.description')}
      action={
        <Button component={Link} to="/" variant="contained">
          {t('notFound.backHome')}
        </Button>
      }
    />
  );
}
